import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false
};

const ableButtonSlice = createSlice({
  name: "ableButton",
  initialState,
  reducers: {
    openableButton(state) {
      state.isOpen = true;
    },
    closeableButton(state) {
      state.isOpen = false;
    },
    toggleableButton(state) {
      state.isOpen = !state.isOpen;
    }
  }
});

export const { openableButton, closeableButton, toggleableButton } = ableButtonSlice.actions;

export default ableButtonSlice.reducer;
